import { html } from "components/send-messages/submit-handler";
import {
  QueryInterestProfile_interest as InterestType,
  TemplateType,
} from "types/gql-types";
import { Action } from "pages/dashboard/interests-profile/components/reason-modal";
import { SendMessageStateValues } from "./message-form";

export type ActionKey = "logCall" | "addNote" | "sendMessage" | "changeStatus";
export const actionKeys: ReadonlyArray<ActionKey> = [
  "changeStatus",
  "logCall",
  "addNote",
  "sendMessage",
];

export const getSwitchesForFocusedAction = (action: Action): Record<ActionKey, boolean> => ({
  logCall: action === Action.LogCall,
  addNote: action === Action.AddNote,
  sendMessage: action === Action.SendMessage,
  changeStatus: action === Action.ChangeStatus,
});

export const hasPropertyUseCases = (interest: InterestType): boolean =>
  interest.interestList.property.propertyUseCases.length > 0;

const isBlank = (value: string | null | undefined): boolean => !value || value.trim().length < 1;

export const validateEmailValues = (values: SendMessageStateValues): string => {
  if (!values.emailEnabled) return "";
  const issues: string[] = [];
  if (values.emailBccAddress && !values.emailBccAddress.match(/@/)) {
    issues.push("A valid BCC email address is required. ");
  }
  const emailBody = html(values.emailBody, TemplateType.EMAIL);
  if (isBlank(emailBody)) {
    issues.push("Email message is required. ");
  }
  return issues.length > 0 ? `If Send an Email is enabled, ${issues.join("")}` : "";
};

export const validateSmsValues = (values: SendMessageStateValues): string => {
  if (!values.smsEnabled) return "";
  const issues: string[] = [];
  const smsBody = html(values.smsBody, TemplateType.SMS);
  if (isBlank(smsBody)) {
    issues.push(" If Send a Text is enabled, a message is required.");
  }
  return issues.join("");
};

export const validateLetterValues = (values: SendMessageStateValues): string => {
  if (!values.letterEnabled) return "";
  const letterBody = html(values.letterBody, TemplateType.LETTER);
  if (!isBlank(letterBody)) return "";
  return "If Send a Letter is enabled, a letter message is required.";
};

export const buildLogCallNote = (reason: string, outcome: string, note: string): string => {
  let prefix = `Outcome: ${outcome}`;
  if (reason) {
    prefix = `Reason: ${reason}. Outcome: ${outcome}`;
  }
  const separator = note ? " - " : "";
  return `${prefix}${separator}${note}`;
};

export const toHtmlBodies = (
  messageValues: SendMessageStateValues,
): { email: string; sms: string; letter: string } => ({
  email: html(messageValues.emailBody, TemplateType.EMAIL),
  sms: html(messageValues.smsBody, TemplateType.SMS),
  letter: html(messageValues.letterBody, TemplateType.LETTER),
});

export const tabActions: Record<ActionKey, Action> = {
  logCall: Action.LogCall,
  addNote: Action.AddNote,
  sendMessage: Action.SendMessage,
  changeStatus: Action.ChangeStatus,
};

export const tabsData: ReadonlyArray<{ key: ActionKey; label: string }> = [
  { key: "logCall", label: "Log a Call" },
  { key: "sendMessage", label: "Send Message" },
  { key: "addNote", label: "Add a Note" },
  { key: "changeStatus", label: "Change Status" },
];
